import { render, staticRenderFns } from "./GlossaryForm.vue?vue&type=template&id=7611ec44&"
import script from "./GlossaryForm.vue?vue&type=script&lang=js&"
export * from "./GlossaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7611ec44')) {
      api.createRecord('7611ec44', component.options)
    } else {
      api.reload('7611ec44', component.options)
    }
    module.hot.accept("./GlossaryForm.vue?vue&type=template&id=7611ec44&", function () {
      api.rerender('7611ec44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/glossary/GlossaryForm.vue"
export default component.exports